<template>
  <div id="fullContents">
        <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
        <div id="suningAgree">
            <p class="center bold" style="font-size: 16px; margin-bottom: 10px;">个人信息采集及使用通用授权书</p>

            <p class="bold">一、定义 </p>
            <p>1、个人信息，指您的如下信息： </p>
            <p>（1）姓名、出生日期、身份证件号码、住址、电话号码、学历、声音、肖像、虹膜及其他类似的生物特征信息、工作信息、家庭信息、社保及公积金缴存信息等个人基本信息。 </p>
            <p>（2）借款申请信息、借款合同信息、还款行为信息、借款逾期信息、欠缴水电煤等公用税费的信息、履约情况信息、涉讼信息、行政处罚信息、违法犯罪信息等个人正常信用信息及不良信用信息。<span class="bold">您已经充分理解并知晓：前述不良信用信息一旦记录在第三方机构的信息数据库中，有可能会对您日后的经济活动产生不同程度的不良影响。</span></p>
            <p>（3）个人收入、存款、有价证券、商业保险、银行卡信息、不动产的信息和纳税数额信息等财产性信息。您已经认识到您的前述财产性信息对您而言是私密且重要的信息。<span class="bold">您已经充分理解并知晓该等信息被提供和使用的风险。这些风险包括但不限于：纳入这些信息对您的信用评级（评分）、信用报告等结果可能产生不利影响，该等信息被被授权人依法提供给第三方后被他人不当利用的风险，因您的信用状况较好而造成您被第三方推销产品或服务等打扰的风险等。</span></p>
            <p>（4）设备信息、社交数据、阅读数据、上网浏览/搜索数据、所用应用程序的账号信息、使用某项服务的时间地点等信息、联系人信息（含通讯录信息、通话记录信息以及您在申请服务过程中提交的联系人信息等）、消费数据（含近期交易笔数、交易金额及消费行为评分数据等）等个人行为特征数据信息。           </p>
            <p>（5）其他任何与您有关联的信息，但法律、法规、监管政策禁止的除外。 </p>
            <p>2、第三方，指与被授权人或您有直接或间接关联的如下主体或机构： </p>
            <p>（1）中国人民银行金融信用信息基础数据库、依法设立的征信机构、资信评估机构或有关法律、监管机构许可的类似信用机构。 </p>
            <p>（2）被授权人关联方、为被授权人提供必要技术和服务的合作方，以及与被授权人合作从事信贷业务的金融机构或互联网金融公司。 </p>
            <p>（3）依法存有您某方面个人信息的其他机构，包括但不限于法院、公积金、社保、税务、民政、物流、通信运营商、电子商务平台、电子认证服务提供者、互联网平台等机构或主体。 </p>
            <p class="bold">二、授权内容 </p>
            <p>因本人/本人名下企业向【江苏苏宁银行股份有限公司】申请个人贷款/企业贷款，基于业务的需要，本人现同意向【江苏苏宁银行股份有限公司】（以下称“被授权人”）及第三方郑重授权如下： </p>
            <p>1、同意被授权人及第三方在办理下列业务（下称“授权用途”）时查询、收集或使用本人的个人信息： </p>
            <p>（1）审核本人/本人名下企业通过被授权人或第三方申请的贷款； </p>
            <p>（2）对已发放的个人/企业信贷进行贷后风险管理及催收； </p>
            <p>（3）出于电子签名方面的需要进行必要的身份注册及认证； </p>
            <p>（4）处理本人征信异议； </p>
            <p>（5）依法或经有权部门要求向第三方提供； </p>
            <p>（6）管理本人通过被授权人或第三方办理的其他业务； </p>
            <p>（7）为向本人提供更优的服务开展必要的市场调研或广告营销； </p>
            <p>（8）其他合法合规的用途。</p>
            <p>2、同意被授权人基于授权用途通过第三方查询、核实、采集本人的个人信息。<span class="bold">为避免每次查询、核实或采集都需要经过本人的反复确认而导致过程繁琐、或者因此给本人带来不便，本人同意第三方可直接向被授权人提供本人的个人信息而不需要本人再次授权。但法律、法规、监管政策禁止的除外。</span></p>
            <p>3、同意被授权人基于授权用途向第三方报送、提供、共享被授权人通过相关渠道获取的本人个人信息。 </p>
            <p>4、同意被授权人及第三方对依法获取的本人个人信息进行保存、分析、加工、整理或处理，包括但不限于将本人的个人信息纳入被授权人或第三方的风险模型并输出相应的信用评分/评级数据等。 </p>
            <p>5、本人知悉并同意：《个人信息采集及使用通用授权书》项下的被授权人有可能并非最终的贷款人，为提高贷款申请的成功率，被授权人有权在适当情形下（包括但不限于贷款申请被拒、被授权人产品形态或经营策略的调整等）将本人的贷款申请及个人信息转交至被授权人的其他合作方（包括但不限于相关的银行、消费金融公司、信托公司或小额贷款公司等），<span class="bold">该种情形下被授权人及其前述新合作方有权直接使用《个人信息采集及使用通用授权书》项下已查得的本人的个人征信信息，并有权将最终的借贷信息（含不良信息）上报中国人民银行金融信用信息基础数据库，被授权人及其新的合作方不需要本人再次授权。</span></p>
            <p class="bold">三、授权期限 </p>
            <p>自本人作出本授权承诺之日起，至本人在被授权人处所有业务终结之日止。本人知悉并同意：本人在被授权人和/或其合作方处有借款额度或授信但无贷款余额的业务关系仍然存续，被授权人仍有权向第三方查询、打印、保存或上报本人的基本信息和信用信息。 </p>
            <p class="bold">四、争议解决 </p>
            <p>若本人与被授权人发生任何纠纷或争议，首先应友好协商解决。协商不成的，本人同意将纠纷或争议提交被授权人所在地有管辖权的人民法院管辖。本授权书的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。 </p>
            
            <br/><br/>
            <p>本人姓名： </p>
            <p>证件名称及号码：身份证 </p>
            <p>签署日期：  年   月   日</p>
        </div>
  </div>
</template>
<script>
export default {
  components: {  },
  name: 'suningPersonalInfoAuthorize',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  mounted() {
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
/* common css */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
p {
  /* margin-bottom: 8px; */
}
#fullContents {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}
#fullContents .crossBox{
  text-align: right;
}
#fullContents .cross{
  font-size: 20px;
}
#suningAgree {
  line-height: 20px;
  text-align: left;
  overflow: scroll;
  -webkit-overflow-scrolling: touch;
}
#suningAgree .title {
    font-size: 15px;
    text-align: center;
}
#suningAgree .bold {
    font-weight: bold;
}
#suningAgree .center {
    text-align: center;
}
#suningAgree .right {
    text-align: right;
}
#suningAgree .underline {
    text-decoration: underline;
}
#suningAgree .write-line {
    overflow: hidden; 
    width: 90%; ;
    margin: 0 auto;
}
</style>
